export const sendReportConstantes = Object.freeze({
  STATUS_IN_PREPARATION: 0,
  STATUS_SENT: 1,
  STATUS_ERROR: 2,
  STATUS_BLOCKED: 3,
});
